import React from 'react';
import ReactDOM from 'react-dom';
import ReactModal from 'react-modal';
import App from './App';
import "./assets/css/style.css";
import './assets/css/bootstrap.min.css';

import 'bootstrap/dist/js/bootstrap.bundle.min';
import "./i18n";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// Set react-modal app element for accessibility (suppresses 'App element is not defined' warning)
ReactModal.setAppElement('#root');

// Toggle class on body to differentiate keyboard tabbing from mouse/touch clicks
window.addEventListener('keydown', (e) => {
  if (e.key === 'Tab') {
    document.body.classList.add('keyboard-nav');
  }
});

window.addEventListener('mousedown', () => {
  document.body.classList.remove('keyboard-nav');
});

window.addEventListener('touchstart', () => {
  document.body.classList.remove('keyboard-nav');
});

